import { Joi } from 'app-webtech-core/schemas';
import { SET_RATINGS } from './types';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';

const setRatingsActionPayloadSchema = Joi.object().keys({
  ratings: Joi.any(),
});

export const setRatingsAction = actionCreator(SET_RATINGS, setRatingsActionPayloadSchema);
